import Codes from "./codes/index";

export default Codes;